import type { Theme } from '@emotion/react';
import { buildTheme } from 'common-ui';
import merge from 'lodash/merge';
import type { CommonThemeVars, ThemeCreateFunction } from 'tsconfig/types';
import { buildThemeMixinsLW, buildThemeWidgetStylesLW, buildThemeVarsLW } from 'dw-uk-law/theme-foundation';

const createTheme: ThemeCreateFunction = () =>
  buildTheme(
    (vars: Pick<Theme, CommonThemeVars>) => merge({}, buildThemeVarsLW(vars)),
    (vars: Omit<Theme, 'mixins' | 'widgets'>) => buildThemeMixinsLW(vars),
    (vars: Omit<Theme, 'widgets'>) => merge({}, buildThemeWidgetStylesLW(vars)),
  );

export default createTheme;
